import { LogUserActivity } from './LogUserActivity';
import { RemoteLogger } from './RemoteLogger';
import { SaveAddress } from './SaveAddress';
import { SaveWorkableItem } from './SaveWorkableItem';

/**
 * mutations
 *
 * @type {{LogUserActivity: ((function({}=): Promise<{}>)|*), Logger: ((function(*): Promise<{}>)|*), SaveAddress:
 *   ((function({}=): Promise<{}>)|*), SaveWorkableItem: ((function({}=): Promise<{}>)|*)}}
 */
export const mutations = {
  Logger: RemoteLogger,
  LogUserActivity,
  SaveAddress,
  SaveWorkableItem,
};
